/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Pro_Title_2Inputs */

const en_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Enjoy Plus Exclusive Trees and <span style="[%2$s]">3x Focus Coins</span>!</span>`)
};

const ar_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">استمتع بأشجار بلس الحصرية و<span style="[%2$s]">عملات التركيز ×3</span>!</span>`)
};

const de_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Genießen Sie Plus Exclusive Trees und <span style="[%2$s]">3x Focus Coins</span>!</span>`)
};

const es_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">¡Disfruta de árboles exclusivos Plus y<span style="[%2$s]">3x monedas de concentración</span>!</span>`)
};

const fr_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Profitez davantage d'Arbres exclusifs et <span style="[%2$s]">triplez vos pièces reçues</span> !</span>`)
};

const it_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> Goditi alberi esclusivi e <span style="[%2$s]">3x monete di concentrazione </span>! </span>`)
};

const ja_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus限定の木と<span style="[%2$s]">3倍のコイン</span>！</span>`)
};

const ko_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus 독점 나무와 <span style="[%2$s]">3배 포커스 코인</span> 혜택을 받으세요!</span>`)
};

const pt_br_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Aproveite as árvores exclusivas do Plus e <span style="[%2$s]">3x moedas por foco</span>!</span>`)
};

const ru_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Наслаждайтесь эксклюзивными деревьями Plus и <span style="[%2$s]">утроенными монетами за фокусировку</span>!</span>`)
};

const th_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">เพลิดเพลินกับต้นไม้สุดพิเศษสำหรับ Plus และ<span style="[%2$s]">เหรียญการโฟกัส 3 เท่า</span>!</span>`)
};

const tr_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus Özel Ağaçların ve <span style="[%2$s]">3x Odaklanma Jetonunun tadını çıkar</span>!</span>`)
};

const zh_cn_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus 独享树种随你种，还能享受<span style="[%2$s]">专注金币 3 倍</span>！</span>`)
};

const zh_tw_subscription_walkthrough_p1_pro_title_2 = /** @type {(inputs: Subscription_Walkthrough_P1_Pro_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plus 獨享樹種隨你種，還能享受<span style="[%2$s]">專注金幣 3 倍</span>！</span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">Enjoy Plus Exclusive Trees and <span style=\"[%2$s]\">3x Focus Coins</span>!</span>" |
*
* @param {Subscription_Walkthrough_P1_Pro_Title_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_pro_title_2 = /** @type {((inputs?: Subscription_Walkthrough_P1_Pro_Title_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Pro_Title_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_pro_title_2(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_pro_title_2(inputs)
	return zh_tw_subscription_walkthrough_p1_pro_title_2(inputs)
});